export default __webpack_public_path__ + "img/8c7aa059b80b5ed9bd78962353accaf6.svg";